import { Component, OnInit } from "@angular/core";
import * as moment from "moment";
import { TableComponent } from "src/app/table.component";
import { OrderSummaryReportService } from "src/services/reports/order-summary.service";

export class OrderSummary {
  orderDate: Date;
  orders: number;
  customers: number;
  basePremium: number;
  fees: number;
  totalPremium: number;
}

@Component({
  selector: "app-order-summary-report",
  templateUrl: "./order-summary-report.component.html",
  styleUrls: ["./order-summary-report.component.css"],
})
export class OrderSummaryReportComponent
  extends TableComponent<OrderSummary>
  implements OnInit
{
  pageTitle = "Order Summary Report";
  startDate: Date;
  endDate: moment.Moment;
  get EndDate() {
    return this.endDate;
  }
  set EndDate(value) {
    if (value) {
      this.endDate = value.endOf("day");
    }
  }

  displayedColumns: string[] = [
    "orderDate",
    "orders",
    "customers",
    "basePremium",
    "fees",
    "totalPremium",
    "netAmount",
  ];

  orderList: OrderSummary[] = [];

  constructor(private reportService: OrderSummaryReportService) {
    super(reportService);
  }

  getCount(): any {
    const data = {
      startDate: this.startDate,
      endDate: this.endDate,
      skip: this.paginator.pageIndex * this.paginator.pageSize,
      take: this.paginator.pageSize,
    };
    return this.reportService.getCount(data);
  }

  getData(): any {
    return {
      startDate: this.startDate,
      endDate: this.endDate,
      skip: this.paginator.pageIndex * this.paginator.pageSize,
      take: this.paginator.pageSize,
      orderBy: this.sort.active,
      orderByDescending: this.sort.direction === "desc",
    };
  }

  getDataByFilter() {
    this.getCount().subscribe((res) => {
      this.count = res.count;
      this.loadRequests();
    });
  }

  downloadXLS(isXLS: boolean) {
    const data = {
      startDate: this.startDate,
      endDate: this.endDate,
      skip: 0,
      take: 2147483647,
      asXLS: isXLS,
    };

    this.reportService.downloadReport(data);
  }

  // getOrderSummeryReports(data: any) {
  //   const lMe = this;
  //   this.reportService.getOrderSummaryReport(data).subscribe(res => {
  //     this.orderList = [];
  //     res.forEach(obj => {
  //       const order = new OrderSummary();
  //       order.orderDate = obj.issueDate;
  //       order.orders = obj.policies;
  //       order.customers = obj.customers;
  //       order.basePremium = obj.amountPaid;
  //       order.fees = obj.fees;
  //       order.totalPremium = order.basePremium * order.fees;

  //       lMe.orderList.push(order);
  //     });

  //     lMe.dataSource = new MatTableDataSource(this.orderList);
  //     setTimeout(() => {
  //       lMe.dataSource.paginator = lMe.paginator;
  //     }, 100);

  //   }, err => {
  //     if (err) {
  //       this.dialogService.errorSanckBar(err);
  //     } else {
  //       this.dialogService.errorSanckBar('Something went wrong. Please contact admin.');
  //     }
  //   });
  // }
}
